<template>
  <SearchTagResult
    :isplayymovie="isplayymovie"
    :key="`search_tag_${componentKey}`"
  />
</template>

<script>
import cookie from '@/common/utils/cookie'
import { UPDATE_PAGING_CONTENT } from '@/common/resources/const'
import SearchTagResult from '@/components/search/SearchTagResult'

export default {
  name: 'SearchTagMain',
  components: {
    SearchTagResult
  },
  data () {
    return {
      componentKey: 0,
      pooqzoneInfo: cookie.getPooqZoneInfo(),
      isplayymovie: 'y' // fixme: isplaymovie -> tabList 결정하기 위함 -> tabList 없어 짐 -> 삭제 예정
    }
  },
  created () {
    if (this.pooqzoneInfo && this.pooqzoneInfo.isPooqzone) {
      this.isplayymovie = this.pooqzoneInfo.isplayymovie
    }
  },
  mounted () {
    this.$events.$on(UPDATE_PAGING_CONTENT, () => {
      this.componentKey += 1
    })
  }
}
</script>
<style lang="scss" src="@/assets/scss/category/member.scss"></style>
